export const GET_ALL_TAGS_PENDING = "GET_ALL_TAGS_START";
export const GET_ALL_TAGS_SUCCESS = "GET_ALL_TAGS_SUCCESS";
export const GET_ALL_TAGS_FAILED = "GET_ALL_TAGS_FAILED";

export const GET_ALL_CAPTIONS_PENDING = "GET_ALL_CAPTIONS_START";
export const GET_ALL_CAPTIONS_SUCCESS = "GET_ALL_CAPTIONS_SUCCESS";
export const GET_ALL_CAPTIONS_FAILED = "GET_ALL_CAPTIONS_FAILED";

export const GET_ALL_CAPTIONS_TAGS_PENDING = "GET_ALL_CAPTIONS_START";
export const GET_ALL_CAPTIONS_TAGS_SUCCESS = "GET_ALL_CAPTIONS_SUCCESS";
export const GET_ALL_CAPTIONS_TAGS_FAILED = "GET_ALL_CAPTIONS_FAILED";
export const GET_ALL_CAPTIONS_TAGS_CLEAR = "GET_ALL_CAPTIONS_TAGS_CLEAR";

export const ADD_CAPTION_PENDING = "ADD_CAPTION_PENDING";
export const ADD_CAPTION_SUCCESS = "ADD_CAPTION_SUCCESS";
export const ADD_CAPTION_FAILED = "ADD_CAPTION_FAILED";

export const ADD_TAGS_PENDING = "ADD_TAGS_PENDING";
export const ADD_TAGS_SUCCESS = "ADD_TAGS_SUCCESS";
export const ADD_TAGS_FAILED = "ADD_TAGS_FAILED";

export const ADD_TAGS_TO_CAPTIONS_PENDING = "ADD_TAGS_TO_CAPTIONS_PENDING";
export const ADD_TAGS_TO_CAPTIONS_SUCCESS = "ADD_TAGS_TO_CAPTIONS_SUCCESS";
export const ADD_TAGS_TO_CAPTIONS_FAILED = "ADD_TAGS_TO_CAPTIONS_FAILED";

export const CREATE_CAPTION_TAGS_PENDING = "CREATE_CAPTION_TAGS_PENDING";
export const CREATE_CAPTION_TAGS_SUCCESS = "CREATE_CAPTION_TAGS_SUCCESS";
export const CREATE_CAPTION_TAGS_FAILED = "CREATE_CAPTION_TAGS_FAILED";

export const CAPTION_MULTIPLE_TAGS_PENDING = "CAPTION_MULTIPLE_TAGS_PENDING";
export const CAPTION_MULTIPLE_TAGS_SUCCESS = "CAPTION_MULTIPLE_TAGS_SUCCESS";
export const CAPTION_MULTIPLE_TAGS_FAILED = "CAPTION_MULTIPLE_TAGS_FAILED";
export const CAPTION_MULTIPLE_TAGS_CLEAR = "CAPTION_MULTIPLE_TAGS_CLEAR";
